module.exports = __webpack_public_path__ + "img/sok-cg-web.97856479.png";